import React, { useEffect, useState } from "react";

function Preloader({ onFinish }) {
  const [count, setCount] = useState(0);
  const duration = 2500; // total 5 seconds
  const increment = 1; // increment by 1

  useEffect(() => {
    if (count < 100) {
      const intervalTime = duration / 100; // 5000ms / 100 = 50ms per increment
      const timer = setTimeout(() => setCount(prev => prev + increment), intervalTime);
      return () => clearTimeout(timer);
    } else {
      onFinish(); // trigger App to render main content
    }
  }, [count, onFinish]);

  return (
    <div className="loading_div">
        <div className="loading_count">
      {count}%
    </div>
    </div>
    
  );
}

export default Preloader;
